/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_State_AcceptedInputs */



/**
* | output |
* | --- |
* | "This invite was already accepted. Sign in to open the workspace." |
*
* @param {Invite_State_AcceptedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const invite_state_accepted = /** @type {((inputs?: Invite_State_AcceptedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_State_AcceptedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This invite was already accepted. Sign in to open the workspace.")
});